import { defineComponent as _defineComponent } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'custom-footer',
  props: {
  footerHidden: Boolean,
  userManaging: Boolean,
},
  setup(__props) {



const year = new Date().getFullYear();

return { __sfc: true,year }
}

})